module.exports = __webpack_public_path__ + "img/breeding.cafd4f1a.svg";